<mat-form-field appearance="outline" [class.gray]="gray" [class.offers]="colors === ColorSchemes.OFFERS">
  <mat-icon matPrefix>search</mat-icon>
  <mat-label>{{ labelKey | locLabel }}</mat-label>
  <input matInput [ngModel]="search" (ngModelChange)="search = $event; searchChange.emit($event)" />
</mat-form-field>
